import packageJson from 'package.json';

export const getWebappVersion = (): string => {
  return packageJson.version || '';
};

export const isTestingEnv = (): boolean => {
  return process.env.NEXT_PUBLIC_TESTING === 'true';
};

export const isClient = (): boolean => {
  return typeof window !== 'undefined';
};

export const getEnv = (): string => {
  const env = isClient() ? process.env.NEXT_PUBLIC_ENVIRONMENT || '' : process.env.ENVIRONMENT || '';
  return ['dev', 'sandbox', 'production'].includes(env) ? env : 'local';
};

export const isTelemetryEnabled = (): boolean => {
  return process.env.NEXT_PUBLIC_TELEMETRY_ENABLED !== 'false';
};
